import axios from "./axios";

/**
 * Current authenticated user (full profile).
 * GET /api/users/user/
 */
export const getCurrentUser = async (options = {}) => {
  const { signal } = options;
  const { data } = await axios.get("/api/users/user/", { signal });
  return data;
};

/**
 * Broker credential field definitions per broker code.
 * GET /api/users/broker-requirements/
 * @returns {Promise<{ schema: Record<string, Array<{ input_name: string, type: string, label: string, placeholder?: string }>> }>}
 */
export const getBrokerRequirements = async (options = {}) => {
  const { signal } = options;
  const { data } = await axios.get("/api/users/broker-requirements/", { signal });
  return data;
};

export const uploadClientTokensFile = async (file, options = {}) => {
  const { signal } = options;
  const formData = new FormData();
  formData.append("client_data_file", file);
  const { data } = await axios.post("/api/users/upload-tokens/", formData, {
    signal,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export function mergeJwtAndProfile(jwtPayload, profile) {
  if (!jwtPayload && !profile) return null;
  if (!profile) return jwtPayload ? { ...jwtPayload } : null;
  const p = profile;
  const jwt = jwtPayload || {};
  return {
    ...jwt,
    id: p.id ?? jwt.id ?? jwt.user_id,
    username: p.username ?? jwt.username,
    email: p.email ?? jwt.email,
    full_name: p.full_name ?? jwt.full_name,
    name: p.full_name ?? jwt.name ?? jwt.username,
    role: p.role ?? jwt.role,
    phone:
      p.phone_number != null && p.phone_number !== ""
        ? String(p.phone_number)
        : jwt.phone ?? "",
    phone_number: p.phone_number,
    last_login: p.last_login ?? jwt.last_login,
  };
}
